import React, { useState, useEffect } from 'react';
import QuestionsText from './QuestionsText';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Spinner from 'react-spinner-material';
import Snackbar from '@material-ui/core/Snackbar';
import * as firebase from 'firebase';
import './styles.css'

var provider = new firebase.auth.FacebookAuthProvider();
provider.addScope('public_profile');
provider.addScope('email');
provider.addScope('user_friends');

export default function Questions({ history }) {

	const [index, setIndex] = useState(0);
	const [questionsValue, setQuestionValue] = useState([]);
	const [questionText, setQuestionText] = useState(QuestionsText.questions[index]);
	const [finish, setFinish] = useState(false)
	const [buttonOneSelected, setButtonOneSelected] = useState(false)
	const [buttonTwoSelected, setButtonTwoSelected] = useState(false)
	const [buttonThreeSelected, setButtonThreeSelected] = useState(false)
	const [buttonFourSelected, setButtonFourSelected] = useState(false)
	const [buttonFiveSelected, setButtonFiveSelected] = useState(false)
	const [backText, setBackText] = useState('Voltar')
	const [backQuestion, setBackQuestion] = useState(false)
	const [loadingPage, setLoadingPage] = useState(true)
	const [openDialog, setOpenDialog] = useState(false);
	const [facebookLogin, setFacebookLogin] = useState(false);
	const [openToast, setOpenToast] = useState(false);
	const [toastMessage, setToastMessage] = useState(false);
	const [runLoad, setRunLoad] = useState(false);
	const [userPicture, setUserPicture] = useState(localStorage.getItem("userPicture") || '');

	useEffect(() => {
		if (loadingPage) {
			console.log("Saved questions")
			console.log(JSON.parse(localStorage.getItem("savedAnswers")))
			const savedQuestions = JSON.parse(localStorage.getItem("savedAnswers"))
			if (saveAnswers != null && savedQuestions != undefined) {
				setQuestionValue(savedQuestions)
				setIndex(savedQuestions.length)
				setQuestionText(QuestionsText.questions[savedQuestions.length]);
			}
			setLoadingPage(false)
		}
		if (finish) {
			localStorage.setItem("savedAnswers", JSON.stringify(questionsValue));
			history.push('/result');
		}

		if (facebookLogin) {
			saveAnswers()
		}
		checkIfQuestionIsSaved()
	}, [finish, questionText, facebookLogin])

	function goBackQuestion() {
		if (index - 1 >= 0) {
			setIndex(index - 1);
			console.log(index);
			setQuestionText(QuestionsText.questions[index - 1]);
			setBackQuestion(true)
			if (index - 1 == 0) {
				setBackText('Voltar')
				setBackQuestion(true)
			}
		} else {
			history.push('/rules2')
		}
		setButtonOneSelected(false)
		setButtonTwoSelected(false)
		setButtonThreeSelected(false)
		setButtonFourSelected(false)
		setButtonFiveSelected(false)
	}

	function checkIfQuestionIsSaved() {

		if (questionsValue[index] != undefined) {
			console.log("saved")
			console.log("Index saved")
			console.log(index)
			if (questionsValue[index] == 1) {
				setButtonOneSelected(true)
			} else if (questionsValue[index] == 2) {
				setButtonTwoSelected(true)
			} else if (questionsValue[index] == 3) {
				setButtonThreeSelected(true)
			} else if (questionsValue[index] == 4) {
				setButtonFourSelected(true)
			} else if (questionsValue[index] == 5) {
				setButtonFiveSelected(true)
			}
		} else {
			setButtonOneSelected(false)
			setButtonTwoSelected(false)
			setButtonThreeSelected(false)
			setButtonFourSelected(false)
			setButtonFiveSelected(false)
		}
	}

	const handleClickQuestionItem = (event) => {
		event.preventDefault();
		if (index + 1 < 135) {
			setBackText('Questão Anterior')
			if (backQuestion) {
				var arrayValues = questionsValue
				arrayValues[index] = parseInt(event.target.value)
				localStorage.setItem("savedAnswers", JSON.stringify(arrayValues));
				setQuestionValue(arrayValues)
			} else {
				var arrayValues = questionsValue
				arrayValues.push(parseInt(event.target.value))
				localStorage.setItem("savedAnswers", JSON.stringify(arrayValues));
				setQuestionValue(arrayValues)
			}
			setButtonOneSelected(false)
			setButtonTwoSelected(false)
			setButtonThreeSelected(false)
			setButtonFourSelected(false)
			setButtonFiveSelected(false)
			setIndex(index + 1);
			setQuestionText(QuestionsText.questions[index + 1]);
		} else {
			setIndex(index + 1);
			console.log(index);
			setQuestionText(QuestionsText.questions[index + 1]);
			console.log(event.target.value)
			var arrayValues = questionsValue
			arrayValues.push(parseInt(event.target.value))
			localStorage.setItem("questions", JSON.stringify(arrayValues));
			setQuestionValue(arrayValues)
			setFinish(true);
		}
	}

	const saveAnswers = (event) => {
		if(event){
			event.preventDefault()
		}
		if (localStorage.getItem("userId") != '' && localStorage.getItem("userId") !== undefined && localStorage.getItem("userId") !== null) {
			firebase.database().ref('saved-answers/' + localStorage.getItem("userId")).set(
				{ questionsValue: questionsValue });
			console.log("Saving answers draft in cloud")
			setToastMessage('Respostas salvas com sucesso :D')
			savedQuestions()
		} else {
			setOpenDialog(true)
			console.log("Saving answers  in local")
			savedQuestions()
		}
	}

	async function savedQuestions() {
		setOpenToast(true)
		await new Promise(r => setTimeout(r, 1000));
		history.push('/home')
	}

	const handleCloseDialog = () => {
		setOpenDialog(false);
	};

	function handleLoginFacebook() {
		setRunLoad(true);
		setOpenDialog(false);
		firebase.auth().signInWithPopup(provider)
			.then(function (result) {
				var token = result.credential.accessToken;
				console.log(result);
				fetch(`https://graph.facebook.com/me?access_token=${token}`)
					.then(function (response) {
						try {
							if (response.ok) {
								return response.json();
							} else {
								throw new Error("HTTP status " + response.status);
							}
						} catch (error) {
							console.log('Error getting response id user');
							return response.json();
						}
					})
					.then(response => {
						console.log(response)
						var userPictureInternal = ''
						try {
							setUserPicture(`https://graph.facebook.com/${response.id}/picture?type=large`)
							userPictureInternal = `https://graph.facebook.com/${response.id}/picture?type=large`
							console.log(`https://graph.facebook.com/me?access_token=${token}`)
						} catch (error) {
							console.log('Error getting user image')
							setUserPicture('')
						}
						localStorage.setItem("name", response.name);
						localStorage.setItem("userId", response.id);
						localStorage.setItem("userPicture", userPictureInternal);
						localStorage.setItem("email", result.user.email);
						localStorage.setItem("token", token);
						localStorage.setItem("facebookLogin", true);
						setFacebookLogin(true)
						console.log("Seted user id")
					});
			}).catch(function (error) {
				var errorCode = error.code;
				var errorMessage = error.message;
				var email = error.email;
				var credential = error.credential;
				setToastMessage('Erro ao fazer login, tente novamente!')
				handleErrorInLogin()
				console.log("ERROR!")
				console.log(error)
				setRunLoad(false);
			});
	}

	function handleCloseErrorInLogin() {
		setOpenToast(false)
	}

	function handleErrorInLogin() {
		setOpenToast(true)
	}

	function goToHome() {
		handleCloseDialog()
		history.push('/home')
	}

	return (
		<>
			<div onClick={goBackQuestion} className='container-arrow'>
				<i className="left"></i>
				<p className='text-back'>{backText}</p>
			</div>
			<p className="number-question"> {`${index + 1}/135`} </p>
			<p className='question-text'>{questionText}</p>
			<form>
				<button type="submit" className={buttonOneSelected ? "btn-selected" : "btn-questions"} onClick={handleClickQuestionItem} value={1}>Nunca</button>
				<button type="submit" className={buttonTwoSelected ? "btn-selected" : "btn-questions"} onClick={handleClickQuestionItem} value={2}>Raramente</button>
				<button type="submit" className={buttonThreeSelected ? "btn-selected" : "btn-questions"} onClick={handleClickQuestionItem} value={3}>Em parte</button>
				<button type="submit" className={buttonFourSelected ? "btn-selected" : "btn-questions"} onClick={handleClickQuestionItem} value={4}>Geralmente</button>
				<button type="submit" className={buttonFiveSelected ? "btn-selected" : "btn-questions"} onClick={handleClickQuestionItem} value={5}>Sempre</button>
				<button type="submit" className='save-questions' onClick={saveAnswers}>Salvar para continuar mais tarde</button>
			</form>
			<span className='spinner' id='load'>
				<Spinner size={60} spinnerColor={"#449AE2"} visible={runLoad} />
			</span>
			<Dialog
				open={openDialog}
				onClose={handleCloseDialog}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description">
				<DialogTitle id="alert-dialog-title">{"Atenção"}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						As respostas já estão salvas no seu computador :D mas para salvar online e ter acesso
						de qualquer lugar faça o login :)
            </DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={goToHome} color="primary">Sair</Button>
					<Button onClick={handleLoginFacebook} color="primary" autoFocus>Fazer login</Button>
				</DialogActions>
			</Dialog>
			<Snackbar
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				key={'bottom,center'}
				open={openToast}
				autoHideDuration={4000}
				onClose={handleCloseErrorInLogin}
				ContentProps={{
					'aria-describedby': 'message-id',
				}}
				message={<span id="message-id">{toastMessage}</span>}
			/>
		</>
	);
}